import { render, staticRenderFns } from "./CheckOut.vue?vue&type=template&id=354c389d&scoped=true"
import script from "./CheckOut.vue?vue&type=script&lang=js"
export * from "./CheckOut.vue?vue&type=script&lang=js"
import style0 from "./CheckOut.vue?vue&type=style&index=0&id=354c389d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354c389d",
  null
  
)

export default component.exports